
























































import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import { mdiAlertCircle, mdiArrowRight } from '@mdi/js';
import SignupModule from '@store/signup';
import AlertBanner from '@components/AlertBanner.vue';
import { Alert, AlertLevel } from '@shared/errors/Alert';
import { RouteName } from '@shared/routing/PageRoutes';
import HorizontalDivider from '@components/HorizontalDivider.vue';
import copy from '@shared/constants/copy';
import { isValidEmail } from '@shared/util/StringUtil';
import { isApiError } from '@shared/api/ErrorTypes';
import SignupFeatures from '@components/auth/SignupFeatures.vue';
import LoginDialog from '@components/auth/LoginDialog.vue';
import ProductTitle from '@components/ProductTitle.vue';

@Component({
    components: {
        ProductTitle,
        LoginDialog,
        HorizontalDivider,
        AlertBanner,
        SignupFeatures,
    },
})
export default class SignUpView extends Vue {
    name = 'SignUpView';
    email: string = '';
    submitting: boolean = false;
    copy = copy;
    mdiArrowRight = mdiArrowRight;
    mdiAlertCircle = mdiAlertCircle;

    get signupModule() {
        return getModule(SignupModule, this.$store);
    }

    get signupError(): Alert | null {
        const verificationResult = this.signupModule.sendVerificationResult;
        if (!isApiError(verificationResult)) {
            return null;
        }
        const error = verificationResult?.error;
        const message = error?.message ?? 'UNKNOWN ERROR';
        return { message, level: AlertLevel.error };
    }

    rules = {
        email: (value: string) => {
            return isValidEmail(value) || 'Please enter a valid email address.';
        },
    };

    inputChanged() {
        this.signupModule.setSendEmailVerificationResult(null);
    }

    updateLoginModal(show: boolean) {
        this.signupModule.setShowLoginModal(show);
    }

    beforeDestroy() {
        this.updateLoginModal(false);
    }

    async submit() {
        this.submitting = true;
        const result = await this.signupModule.submitPreRegistration(this.email);
        if (!isApiError(result) && result.sent) {
            await this.$router.push({ name: RouteName.verifyEmailSent });
        }
        this.submitting = false;
    }
}
